import { useEffect, useState, useCallback } from 'react';
import { fetchGraphql } from '../graphql/fetch';

export interface ViewerEntry {
  rank:    number | null;
  score:   number | null;
  entries: number | null;
}

export function useViewerEntry({ extraId }: { extraId: string | number }): ViewerEntry {
  const [state, setState] = useState<ViewerEntry>({ rank: null, score: null, entries: null });

  const refetch = useCallback(async () => {
    const res = await fetchGraphql<{ viewerLeaderboardEntry: { rank: number | null; score: number | null; entries: number | null } | null }>({
      query: `query VE($id: ID!) {
        viewerLeaderboardEntry(extraId: $id) {
          ... on ParticipantLeaderboardEntry { rank score entries }
          ... on TeamLeaderboardEntry        { rank score entries }
        }
      }`,
      variables: { id: extraId }
    });
    const e = ((res && res.data && res.data.viewerLeaderboardEntry) || null) as { rank: number | null; score: number | null; entries: number | null } | null;
    setState({
      rank:    e && e.rank != null ? e.rank : null,
      score:   e && e.score != null ? e.score : null,
      entries: e && e.entries != null ? e.entries : null
    });
  }, [extraId]);

  useEffect(() => { refetch(); }, [refetch]);

  return state;
}
